import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import bookIcon from '../../assets/images/icon/book.svg';
import emailIcon from '../../assets/images/icon/email.svg';
import fbIcon from '../../assets/images/icon/facebook.svg';
import igIcon from '../../assets/images/icon/instagram.svg';
import phoneIcon from '../../assets/images/icon/phone.svg';
import tgIcon from '../../assets/images/icon/telegram.svg';
import viberIcon from '../../assets/images/icon/viber.svg';
import ytIcon from '../../assets/images/icon/youtube.svg';
import logo from '../../assets/images/logo-light.png';

export default function Page() {
  const REACT_APP_BACKEND_URL = process.env.REACT_AsPP_BACKEND_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get('uid');

  const [shop, setShopData] = useState(null);

  useEffect(() => {
    async function fetchShop() {
      try {
        const res = await fetch(
          `https://api.zochil.io/v3/storefront/shops/${paramValue}`,
        );
        const data = await res.json();
        if (!(data.shop.expired || !data.shop.is_subscribed)) {
          //  window.location.href = `https://${data.shop.uid}.zochil.shop`;
          window.location.href = `https://localhost:3000.zochil.shop`;
        }
        setShopData(data.shop);
      } catch (e) {
        console.log(e);
      }
    }
    fetchShop();
  }, []);

  function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.toString();
    const midpoint = Math.ceil(phoneNumber.length / 2);

    const part1 = phoneNumber.slice(0, midpoint);
    const part2 = phoneNumber.slice(midpoint);

    return `${part1}-${part2}`;
  }

  return (
    <div className="px-4 h-100">
      <div className="expired-container h-100">
        <div className="expired-card">
          <div className="expired-card-header">
            <img src={logo} height="32" alt="Landrick" />
          </div>
          <div className="expired-card-body">
            <div className="">
              {shop && (
                <img
                  src={shop.logo}
                  className="img-fluid avatar avatar-medium rounded-circle shadow"
                  alt=""
                />
              )}
            </div>
            {shop && <h5 className="mb-0 pt-3">{shop.name}</h5>}
            <p className="expired-card-warning">
              Дэлгүүрийн вэбсайтын хугацаа дууссан байна.
            </p>
            <div className="expired-card-footer">
              <div className="d-flex contact-detail align-items-center">
                <img
                  src={phoneIcon}
                  alt="phone:"
                  className="expired-contact-icon"
                />
                {shop && (
                  <a
                    href={`tel:${shop.phone}`}
                    className="text-primary-expired"
                  >
                    (+976) {shop ? formatPhoneNumber(shop.phone) : '7777-8787'}
                  </a>
                )}
              </div>
              <div className="d-flex contact-detail align-items-center">
                <img
                  src={emailIcon}
                  alt="email:"
                  className="expired-contact-icon"
                />
                {shop && (
                  <a
                    href={`mailto:${shop.email}`}
                    className="text-primary-expired"
                  >
                    {shop ? shop.email : 'crm@zochil.mn'}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="expired-social-container">
          <p className="expired-text mb-0">
            Хэрэв та онлайн худалдааны вэбсайттай болохыг хүсч байвал бидэнтэй
            холбогдоно уу.
          </p>
          <p className="expired-text mb-5">Холбоо барих: 7777-8787</p>
          {/* <a
            href="https://share.hsforms.com/197Jvqmx8Q4eMXHvtl54f0Aq0to9"
            className="expired-register"
          >
            Бүртгүүлэх
          </a> */}
          <div className="expired-social-wrapper mt-5">
            <a
              className="expired-social-link lift"
              href="https://help.zochil.mn/zochil-docs/delg-r-udirdakh/ndsen-b-rtgel/b-rtg-lekh"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={bookIcon} alt="doc" />
            </a>
            <a
              className="expired-social-link lift"
              href="https://www.instagram.com/zochil.platform/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={igIcon} alt="ig" />
            </a>
            <a
              className="expired-social-link lift"
              href="https://www.facebook.com/messages/t/7276094965816020/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fbIcon} alt="fb" />
            </a>
            <a
              className="expired-social-link lift"
              href="https://t.me/zochilnews"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={tgIcon} alt="ig" />
            </a>
            <a
              className="expired-social-link lift"
              href="https://invite.viber.com/?g2=AQAWCZK79FI%2FaFEuAIBskEKRU0Ewgy7V4zCHMx9i3HF3uvWqTLS%2FEuCAZNZm3jGT"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={viberIcon} alt="ig" />
            </a>
            <a
              className="expired-social-link lift"
              href="https://www.youtube.com/@zochilplatform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ytIcon} alt="yt" />
            </a>
          </div>
          <small className="expired-legal">
            Зочил Технологи ХХК &copy;{new Date().getFullYear()} бүх эрх хуулиар
            хамгаалагдсан.
          </small>
        </div>
      </div>
    </div>
  );
}
